import React, { useEffect } from "react";
import { BonadocsEditorViewActionsCode } from "./BonadocsEditorViewActionsCode/BonadocsEditorViewActionsCode";
import { BonadocsEditorViewActionsSidebar } from "./BonadocsEditorViewActionsSidebar/BonadocsEditorViewActionsSidebar";
import BonadocsEditorViewActionsOutput from "./BonadocsEditorViewActionsOutput/BonadocsEditorViewActionsOutput";
import { ethers } from "ethers";
import { blockTag } from "@/utils/latestBlock";
import { supportedChains } from "@bonadocs/core";
export const BonadocsEditorViewActionsWrapper: React.FC = () => {
  useEffect(() => {
    if (!blockTag) {
      localStorage.setItem("zimulatoor-block-tag", JSON.stringify({}));
    } else updateBlockNumbers();
  }, []);

  const updateBlockNumbers = async () => {
    const expiredChains = Object.keys(blockTag).filter(
      (chainId) =>
        blockTag[chainId].expireAt !== undefined &&
        blockTag[chainId].expireAt < Date.now()
    );

    if (expiredChains.length > 0) {
      expiredChains.forEach(async (expiredChain) => {
        const currentChain = Array.from(supportedChains).filter((instance) => {
          if (Number(expiredChain) === instance[0]) {
            return {
              label: instance[1].name,
              value: instance[1].chainId,
            };
          }
        });

        const rpcUrl = currentChain[0]?.[1].jsonRpcUrl;
        const blockNumber = await getLatestBlock(rpcUrl);

        blockTag[expiredChain].expireAt = Date.now() + 3600000;
        blockTag[expiredChain].blockTag = blockNumber;
      });
    }
  };

  async function getLatestBlock(rpcUrl: string) {
    const provider = new ethers.JsonRpcProvider(rpcUrl);
    const blockNumber = await provider.getBlockNumber();
    return blockNumber;
  }

  return (
    <>
      <BonadocsEditorViewActionsSidebar />
      <BonadocsEditorViewActionsCode />
      <BonadocsEditorViewActionsOutput />
    </>
  );
};
